function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartLine = function SvgHeartLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "\\u56FE\\u5C42 1",
    viewBox: "0 0 1024 1024"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M690.72 148.42c-47.61 0-80.72 16.67-134.37 60.42-2.49 2-16.54 13.58-20.61 16.88a38.44 38.44 0 0 1-48 0c-4.07-3.31-18.12-14.85-20.61-16.88-53.65-43.75-86.76-60.42-134.37-60.42C188 148.42 95.1 259.05 95.1 418.71c0 121.74 130.42 272.84 395.54 448a38.62 38.62 0 0 0 42.21 0c265.15-175.15 395.54-326.26 395.54-448 0-159.66-92.89-270.29-237.67-270.29M690.33 76c189.24 0 310.52 145.78 310.52 342 0 152.3-143.4 320-425.95 508.48a114.63 114.63 0 0 1-126.31 0C166.05 738.05 22.64 570.33 22.64 418c0-196.22 121.29-342 310.52-342 68.34 0 114.7 23 178.59 75C575.65 98.92 622 76 690.33 76",
    style: {
      fill: "#040000"
    }
  }));
};
export default SvgHeartLine;